import { CompetenceTree } from '@/components/LearningPath/SettingsNodes/components/CompetenciesList';
import { useGet } from '@/query/fetchHooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const AllCompetencies = ({ coursecontentId }) => {
  const { t } = useTranslation();
  const [courseCompetencies, setCourseCompetencies] = useState(null);

  useGet(`/coursecontenteffectivecompetences`, {
    coursecontentId: coursecontentId,
    sourceType:
      'coursecontent,OR,sourceType=directory,OR,sourceType=lesson,OR,sourceType=widget',
    enabled: !!coursecontentId,
    onSuccess: (result) => {
      setCourseCompetencies(result?.data);
    },
  });

  const lessonResult = useGet('/usedlessonassets', {
    count: 10000,
    coursecontentId,
    enabled: Boolean(coursecontentId),
  });
  const directoryResult = useGet('/directoriedetails', {
    count: 10000,
    coursecontentId,
    enabled: Boolean(coursecontentId),
  });

  const lessonData = lessonResult?.data?.data;
  const directoryData = directoryResult?.data?.data;
  const structureIsLoaded =
    Array.isArray(lessonData) && Array.isArray(directoryData);
  const lessons = structureIsLoaded
    ? lessonData.filter(
        (lesson) =>
          lesson.lessonId && !lesson.rootLessonId && !lesson.rootDirectoryId
      )
    : [];
  const directories = structureIsLoaded ? directoryData : [];

  if (!courseCompetencies) return null;

  return (
    <>
      {courseCompetencies?.length > 0 ? (
        <CompetenceTree
          data={courseCompetencies}
          lessons={lessons}
          directories={directories}
        />
      ) : (
        <div className="flex flex-col items-center px-4 pt-8">
          <div className="mb-8">
            <img
              className="m-auto w-48"
              src="/images/components/notifications/theo-empty-inbox.svg"
            />
          </div>
          <div className="mb-4 max-w-[320px] text-center">
            <p className="text-base font-semibold text-black">
              {t('empty_tenplate.competencies_list')}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default AllCompetencies;
